import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import { CompaniesCard } from "../Cards/CompaniesCard";
import MembersContext from "../../../../application/Context/MembersContext";
import { motion } from "framer-motion";
import { InfoBar } from "../InfoBar";
import { Loading } from "../../shared-components/Loading/Loading";
import { NotFound } from "../../shared-components/NotFound";
import { Pagination } from "../../../react-components/members-components/Pagination";
export var Members = function () {
    var _a = useContext(MembersContext), companies = _a.companies, companiesIsLoading = _a.companiesIsLoading, count = _a.count;
    return companiesIsLoading ? (_jsx(Loading, {})) : companies.length > 0 ? (_jsxs(React.Fragment, { children: [_jsxs(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 }, exit: { opacity: 0 }, children: [_jsx(InfoBar, { elements: count }), companies.map(function (company, i) {
                        return (_jsx(CompaniesCard, { item: company }, i));
                    })] }), _jsx(Pagination, {})] })) : (_jsxs(React.Fragment, { children: [_jsx(InfoBar, { elements: count }), _jsx(NotFound, {})] }));
};
